export enum Services {
  IAM = 'iam',
  SUBSCRIPTION = 'subscriptions',
  THINGS = 'things',
  REPORTING = 'reporting',
  SCHEDULER = 'scheduler',
  RULE_ENGINE = 'rule-engine',
  DATA = 'data',
  DASHBOARD = 'dashboard',
  VISUALIZATION = 'visualizations',
  DATA_OP = 'dataop',
}

export interface ApiResponse<T> {
  code: number;
  messageKeys: string;
  message: string;
  result?: T;
}
